import React, { Fragment } from 'react'
import { Button } from 'react-bootstrap'
import { connect } from 'react-redux'
import MEModal from '../../components/MEModal'
import PropTypes from 'prop-types'
import { bulkUploadGrades } from '../actions'
import ButterToast, { Cinnamon } from 'butter-toast'

class BulkUploadGrades extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modalOpen: false,
    }
    this.toggleModal = this.toggleModal.bind(this)
    this.submit = this.submit.bind(this)
  }

  toggleModal() {
    this.setState({
      modalOpen: !this.state.modalOpen,
    })
  }

  async submit(e) {
    e.preventDefault()
    this.toggleModal()

    let resp = await this.props.bulkUpload()

    if (resp.status === 204) {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            scheme={Cinnamon.Crunch.SCHEME_GREY}
            content="We have started bulk uploading grades, a completed task will appear once we are done."
            title="Success"
          />
        ),
      })
    } else {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            scheme={Cinnamon.Crunch.SCHEME_RED}
            content="There was an error trying to bulk upload grades."
            title="Results"
          />
        ),
      })
    }
  }

  render() {
    if (this.props.lmsCourse) {
      return (
        <Fragment>
          <Button bsStyle="link" onClick={this.toggleModal}>
            <i className="fal fa-fw fa-upload" /> Bulk Upload Grades
          </Button>
          <MEModal
            show={this.state.modalOpen}
            close={this.toggleModal}
            title="Confirm"
          >
            <p>Would you like to upload all grades to Canvas?</p>
            <form onSubmit={e => e.preventDefault()}>
              <Button
                type="submit"
                className="btn-myed btn-primary-myed"
                bsStyle="primary"
                onClick={this.submit}
              >
                Yes
              </Button>
              <Button
                type="submit"
                className="btn-myed btn-default-myed"
                bsStyle="default"
                onClick={this.toggleModal}
              >
                No
              </Button>
            </form>
          </MEModal>
        </Fragment>
      )
    } else {
      return null
    }
  }
}

BulkUploadGrades.propTypes = {
  lmsCourse: PropTypes.bool,
  bulkUpload: PropTypes.func,
}

const mapStateToProps = state => {
  return {
    lmsCourse: state.courseLms,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    bulkUpload: () => dispatch(bulkUploadGrades()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BulkUploadGrades)
